// extracted by mini-css-extract-plugin
module.exports = {"slot":"visuals_slot__WSWy7","split":"visuals_split__j3qT2","illustration":"visuals_illustration__Zpzpu"};